var CurrentUser = require("lib/account/CurrentUser");
var ProgressBar = require("components/utility/ProgressBar");

import { Prompt } from "react-router-dom";

require("users/students/student_cloze_status.scss");

class StudentClozeStatus extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { hidden: false };
	}

	openTotalReader() {
		$wr.redirect("/cloze");
	}
	backHome() {
		$wr.redirect("/");
	}

	render() {
		if (this.state.hidden) {
			return <div />
		}

		if (this.props.status.current == 0) {
			var title = "Ready for your Reading Challenge?";
			var message = "Take the Challenge and watch your reading soar like Owlfonso!";
		} else if (this.props.status.current < this.props.status.target) {
			var title = "Continue your Reading Challenge!";
			var message = "Keep soaring and earning coins.";
		} else {
			var title = "You completed the Reading Challenge!";
			var message = "You soared! Owlfonso is very proud.";
		}

		if (this.props.action == StudentClozeStatus.START) {
			var button = (
				<button className="btn buttonPrimary actionButton" onClick={ this.openTotalReader }>
					Take the Challenge!
				</button>
			);
		} else if (this.props.action == StudentClozeStatus.RETAKE) {
			var button = (
				<button className="btn buttonPrimary actionButton" onClick={ this.props.onAction }>
					Take Another!
				</button>
			);
		} else {
			var button = (
				<button className="btn buttonPrimary actionButton" onClick={ this.backHome }>
					Back Home!
				</button>
			)
		}

		return (
			<div className="studentClozeStatus">
				<div className="cLeft">
					<p className="clozeHeader">
						{ title }
					</p>
					<p>
						{ message }
					</p>
				</div>

				<ProgressBar current={ this.props.status.current } total={ this.props.status.target } />
				{ button }
			</div>
		)
	}

};

StudentClozeStatus.propTypes = StrictPropTypes({
	status: PropTypes.object.isRequired,
	action: PropTypes.string.isRequired,
	onAction: PropTypes.func
});

StudentClozeStatus.START = "start";
StudentClozeStatus.RETAKE = "retake";
StudentClozeStatus.DONE = "done";

module.exports = StudentClozeStatus;



// WEBPACK FOOTER //
// ./modules/components/users/students/StudentClozeStatus.js